export default "__VITE_ASSET__D$npOJyT__"